<template>
    <b-col class="animated fadeIn" sm="12">
        <b-card>
            <b-form-group :label="this.$t('name')" label-for="name" :label-cols="2" :horizontal="true">
                <b-form-input id="name" type="text" v-model="name"></b-form-input>
            </b-form-group>

            <b-form-group :label="this.$t('level')" label-for="level" :label-cols="2"
                :description="$t('roleLevelDescription')" :horizontal="true">
                <b-form-input id="level" type="number" v-model.number="level"></b-form-input>
            </b-form-group>

            <b-form-group :label="this.$t('workspaces')" label-for="workspaces" :label-cols="2" :horizontal="true">

                <b-form-select id="workspaces" type="text" v-model="spaces" :options="workspaces"
                    multiple></b-form-select>
            </b-form-group>

            <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-1 variant="dark">{{ $t('platform') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-group v-for="(role, prop) in rolesPlatform" :key="prop"
                                :label="formatComponentName(prop)" :label-cols="2">
                                <b-form-checkbox-group style="margin-top: 5px">
                                    <div class="custom-control custom-checkbox custom-control-inline"
                                        v-for="(perm, index) in role" :key="index">
                                        <input type="checkbox" class="custom-control-input" :value="perm + ' ' + prop"
                                            :id="perm + '-' + prop" v-model="perms">
                                        <label class="custom-control-label" :for="perm + '-' + prop">{{ perm }}</label>
                                    </div>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-2 variant="dark">{{ $t('components') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-group v-for="(role, prop) in componentsPermissions" :key="prop"
                                :label="formatComponentName(prop)" :label-cols="2">
                                <b-form-checkbox-group style="margin-top: 5px">
                                    <div class="custom-control custom-checkbox custom-control-inline"
                                        v-for="(perm, index) in role" :key="index">
                                        <input type="checkbox" class="custom-control-input" :value="perm + ' ' + prop"
                                            :id="perm + '-' + prop" v-model="perms">
                                        <label class="custom-control-label" :for="perm + '-' + prop">{{ perm }}</label>
                                    </div>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-3 variant="dark"
                            :disabled="Object.keys(rolesIntegrations).length < 1">{{ $t('integrations.title')
                            }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-group v-for="(role, prop) in rolesIntegrations" :key="prop"
                                :label="formatComponentName(prop)" :label-cols="2">
                                <b-form-checkbox-group style="margin-top: 5px; z-index: 999">
                                    <div class="custom-control custom-checkbox custom-control-inline"
                                        v-for="(perm, index) in role" :key="index">
                                        <input type="checkbox" class="custom-control-input" :value="perm + ' ' + prop"
                                            :id="perm + '-' + prop" v-model="perms">
                                        <label class="custom-control-label" :for="perm + '-' + prop">{{ perm }}</label>
                                    </div>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-4 variant="dark"
                            :disabled="Object.keys(rolesApps).length < 1">{{ $t('apps') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-group v-for="(role, prop) in rolesApps" :key="prop"
                                :label="formatComponentName(prop)" :label-cols="2">
                                <b-form-checkbox-group style="margin-top: 5px; z-index: 999">
                                    <div class="custom-control custom-checkbox custom-control-inline"
                                        v-for="(perm, index) in role" :key="index">
                                        <input type="checkbox" class="custom-control-input" :value="perm + ' ' + prop"
                                            :id="perm + '-' + prop" v-model="perms">
                                        <label class="custom-control-label" :for="perm + '-' + prop">{{ perm }}</label>
                                    </div>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-6 variant="dark"
                            :disabled="Object.keys(functionsPerms).length < 1">{{ $t('functions.title') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-group v-for="(role, prop) in functionsPerms" :key="prop"
                                :label="formatComponentName(prop)" :label-cols="2">
                                <b-form-checkbox-group style="margin-top: 5px; z-index: 999">
                                    <div class="custom-control custom-checkbox custom-control-inline"
                                        v-for="(perm, index) in role" :key="index">
                                        <input type="checkbox" class="custom-control-input" :value="perm + ' ' + prop"
                                            :id="perm + '-' + prop" v-model="perms">
                                        <label class="custom-control-label" :for="perm + '-' + prop">{{ perm }}</label>
                                    </div>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-7 variant="dark"
                            :disabled="Object.keys(thunderPerms).length < 1">{{ $t('thunder') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-group v-for="(role, prop) in thunderPerms" :key="prop"
                                :label="formatComponentName(prop)" :label-cols="2">
                                <b-form-checkbox-group style="margin-top: 5px; z-index: 999">
                                    <div class="custom-control custom-checkbox custom-control-inline"
                                        v-for="(perm, index) in role" :key="index">
                                        <input type="checkbox" class="custom-control-input" :value="perm + ' ' + prop"
                                            :id="perm + '-' + prop" v-model="perms">
                                        <label class="custom-control-label" :for="perm + '-' + prop">{{ perm }}</label>
                                    </div>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>

            <b-form-group :label-cols="1" :horizontal="true">
                <button class="btn btn-success pull-right" @click="save">{{ $t('save') }}</button>
            </b-form-group>
        </b-card>
    </b-col>
</template>

<script>
import _ from "lodash"

export default {
    name: "Edit",

    data: function () {
        return {
            name: "",
            level: null,
            perms: [],
            spaces: []
        }
    },
    computed: {
        rolesPlatform() {
            return this.permissionsList.platform
        },

        permissionsList() {
            return this.$store.getters.permissionsList
        },

        componentsPermissions() {
            return this.permissionsList.components
        },

        workspaces() {
            return this.$store.getters.getCurrentProject.workspaces.map(w => {
                return {
                    text: w.name,
                    value: w.uuid
                }
            })
        },

        rolesIntegrations() {
            return this.permissionsList.integrations
        },

        platformApps() {
            return this.$store.getters.getApps
        },

        rolesApps() {
            return this.permissionsList.platform_apps
        },

        functionsPerms() {
            return this.permissionsList.functions
        },

        thunderPerms() {
            return this.permissionsList.thunders
        }
    },
    methods: {
        formatComponentName(val) {
            return _.startCase(val.replaceAll("thunder", ""))
        },

        save() {
            this.$http.post("/v1/user/role/create", { name: this.name, level: this.level, permissions: this.perms, workspaces: this.spaces }).then(resp => {

                this.$bvToast.toast("Role created", {
                    variant: 'success',
                    title: "Success"
                })

                this.$router.push({ path: "/admin/users/roles" })
            }).catch(err => {
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger',
                    title: this.$t('error')
                })

            })
        },

        remove() {
            this.$http.delete("/v1/user/role/delete/" + this.$route.params.id).then(() => {
                this.$router.push({ path: "/admin/users/roles" })
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        },

        permSelected(perm, prop) {
            let seePerm = "see " + prop;
            if (this.perms.indexOf(seePerm) == -1) {
                this.perms.push(seePerm)
            }

            let p = perm + " " + prop;
            if (this.perms.indexOf(p) == -1) {
                let c = 0
                this.perms.forEach(el => {
                    let e = el.split(" ");
                    if (e[1] == prop && e[0] != perm) {
                        c++
                    }
                })

                if (c == 1) {
                    this.perms = this.perms.filter(el => {
                        return el != "see " + prop
                    })
                }
            }

            if (seePerm == perm + ' ' + prop) {
                this.perms = this.perms.filter(el => {
                    let e = el.split(" ");
                    return prop != e[1]
                })
            }
            //}
        }
    },
    mounted() {
        this.$store.dispatch("fetchPermissionsList")
    }
}
</script>

<style scoped>
.custom-control {
    z-index: 9999;
    cursor: pointer;
}
</style>